import permissionService from '@services/permissionService';

export default {
  computed: {
    hasProviderId() {
      return permissionService.hasProviderId();
    },
    isAdmin() {
      return permissionService.isAdmin();
    },
    isGas() {
      return permissionService.isGas();
    },
    isGav() {
      return permissionService.isGav();
    },
    isGasGav() {
      return permissionService.isGasGav();
    },
    isOwner() {
      return permissionService.isOwner();
    },
    isDeveloper() {
      return permissionService.isDeveloper();
    },
    isPrestataire() {
      return permissionService.isPrestataire();
    },
    isPartenaire() {
      return permissionService.isPartenaire();
    },
    isHousekeeper() {
      return permissionService.isHousekeeper();
    },
    isCommercial() {
      return permissionService.isCommercial();
    },
    myUserId() {
      return permissionService.myUserId();
    },
    myEmployeeId() {
      return permissionService.myEmployeeId();
    },
    myCompanyId() {
      return permissionService.myCompanyId();
    },
    myOwnerId() {
      return permissionService.myOwnerId();
    },
    myPartenaireId() {
      return permissionService.myPartenaireId();
    },
    myHousekeeperId() {
      return permissionService.myHousekeeperId();
    },
    myCommercialId() {
      return permissionService.myCommercialId();
    },
    isPoleComptabiliteMandante() {
      return permissionService.isPoleComptabiliteMandante();
    },
    isPoleTech() {
      return permissionService.isPoleTech();
    },
    isGasGavOrCommercial() {
      return permissionService.isGasGav() || permissionService.isCommercial();
    },
    myUserDisplay() {
      const userInfo = permissionService.myUserInformation();
      return userInfo.firstName + ' ' + userInfo.lastName;
    },
    myAccommodationIds() {
      return permissionService.myAccommodationIds();
    },
  },
  methods: {
    isMe(userId) {
      return permissionService.isMe(userId);
    },
    hasPermission(permission) {
      return permissionService.hasPermission(permission);
    },
    hasOneOfThem(permissions) {
      return permissionService.hasOneOfThem(permissions);
    },
    canAccessAccommodation(accommodationId) {
      // TODO: ajouter les autres rôles
      if (this.isGasGav) return true;
      if (this.isHousekeeper) return this.myAccommodationIds.includes(accommodationId);
      return true;
    },
  },
};
